import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { Registry } from 'vscode/vscode/vs/platform/registry/common/platform';
import { Extensions } from 'vscode/vscode/vs/workbench/common/contributions';
import { IBannerService } from 'vscode/vscode/vs/workbench/services/banner/browser/bannerService.service';
import { IStorageService } from 'vscode/vscode/vs/platform/storage/common/storage.service';
import { IBrowserWorkbenchEnvironmentService } from 'vscode/vscode/vs/workbench/services/environment/browser/environmentService.service';
import { URI } from 'vscode/vscode/vs/base/common/uri';
import { ThemeIcon } from 'vscode/vscode/vs/base/common/themables';

var WelcomeBannerContribution_1;
let WelcomeBannerContribution = class WelcomeBannerContribution {
    static { WelcomeBannerContribution_1 = this; }
    static { this.WELCOME_BANNER_DISMISSED_KEY = 'workbench.banner.welcome.dismissed'; }
    constructor(bannerService, storageService, environmentService) {
        const welcomeBanner = environmentService.options?.welcomeBanner;
        if (!welcomeBanner) {
            return;
        }
        if (storageService.getBoolean(WelcomeBannerContribution_1.WELCOME_BANNER_DISMISSED_KEY, 0 , false)) {
            return;
        }
        let icon = undefined;
        if (typeof welcomeBanner.icon === 'string') {
            icon = ThemeIcon.fromId(welcomeBanner.icon);
        }
        else if (welcomeBanner.icon) {
            icon = URI.revive(welcomeBanner.icon);
        }
        bannerService.show({
            id: 'welcome.banner',
            message: welcomeBanner.message,
            icon,
            actions: welcomeBanner.actions,
            onClose: () => {
                storageService.store(WelcomeBannerContribution_1.WELCOME_BANNER_DISMISSED_KEY, true, 0 , 1 );
            }
        });
    }
};
WelcomeBannerContribution = WelcomeBannerContribution_1 = ( __decorate([
    ( __param(0, IBannerService)),
    ( __param(1, IStorageService)),
    ( __param(2, IBrowserWorkbenchEnvironmentService))
], WelcomeBannerContribution));
( Registry.as(Extensions.Workbench))
    .registerWorkbenchContribution(WelcomeBannerContribution, 3 );
